import { createSlice, createAction, PayloadAction } from '@reduxjs/toolkit';
import { RequestStatus } from 'shared/constants/State';

export interface CheckPasswordLinkRequestState {
  status: RequestStatus;
  validlink: boolean | null;
  error: string | null;
}

export interface CheckPassowrdLinkAction {
  uidb36: string;
  passToken: string;
}

export const initialState: CheckPasswordLinkRequestState = {
  status: RequestStatus.Ready,
  validlink: null,
  error: null,
};

const name = '@webapp/auth2/check-password-link-request';

const slice = createSlice({
  name,
  initialState,
  reducers: {
    pending: (state) => ({
      ...state,
      status: RequestStatus.Pending,
      validlink: null,
      error: null,
    }),
    error: (state, action: PayloadAction<string>) => ({
      ...state,
      status: RequestStatus.Error,
      validlink: null,
      error: action.payload || 'UnknownError',
    }),
    success: (state, action: PayloadAction<boolean>) => ({
      ...state,
      status: RequestStatus.Success,
      validlink: action.payload,
      error: null,
    }),
  },
});

export const check = createAction<CheckPassowrdLinkAction>(`${name}/check`);

export const { pending, error, success } = slice.actions;
export default slice.reducer;
